export class MflShortOutcomes {
    id: number;
    indicator: string;
    plan: number;
    period1: string;
    fact1: number;
    period2: string;
    fact2: number;
    period3: string;
    fact3: number;
    period4: string;
    fact4: number;
    program_ref: any;
    mpl_ref: any;
    sort_index: number;
}